<template>
  <v-dialog
    :value="value"
    @input="$emit('input')"
    max-width="600px"
    content-class="ims-standard-dialog"
  >
    <v-card class="ims-modal-card">
      <v-card-title class="title ims-modal-header">
        <span>Attached Media</span>
        <v-spacer></v-spacer>
        <v-btn icon color="secondary" aria-label="Close" title="Close" @click="$emit('input')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="ims-modal-body payout-screenshots-body">
        <v-container fluid class="pa-0">
        <!-- posts -->
        <div class="pb-5" v-if="hasPosts">
          <div class="h3 mt-2">Posts</div>
          <v-divider class="ma-0 mb-4"></v-divider>
          <div class="mb-5" :key="firstIndex" v-for="(allPost, firstIndex) in imagesToView.posts">
            <v-row justify="start" align="left">
              <v-col md="4" xs="12" :key="imgIndex" v-for="(img, imgIndex) in allPost.images">
                <v-card text tile>                      
                  <v-hover>
                    <video
                    v-if="getMediaType(img.url) === 'video'"
                    width="180px"
                    height="200px"
                    :src="img.url"
                    controls>             
                        Your browser does not support the video tag.
                    </video>
                    <v-img
                      :src="img.url"
                      :lazy-src="img.url"
                      aspect-ratio="1"
                      class="grey lighten-2 mx-auto"
                      slot-scope="{ hover }"
                      :class="`elevation-${hover ? 12 : 2}`"
                      @click="viewMedia(img.url)"
                      v-else
                    />
                  </v-hover>
                </v-card>
              </v-col>
              <v-col class="pt-0" md="12" xs="12" v-if="allPost.instagramPostURL !== '' || allPost.images.length > 0">
                <a :href="allPost.instagramPostURL" target="_blank">
                  <v-btn small color="secondary" class="mt-2"><v-icon float-left>remove_red_eye</v-icon> Open URL</v-btn>
                </a>
              </v-col>
              <!-- <v-col md="12" xs="12" v-if="allPost.instagramPostURL !== '' || allPost.images.length > 0">
                <v-divider class="ma-0"></v-divider>
              </v-col> -->
            </v-row>
          </div>
        </div>

        <!-- posts -->
        <div class="pb-5" v-if="hasStories">
          <div class="h3 mt-2">IG Stories</div>
          <v-divider class="ma-0 mb-4"></v-divider>
          <div class="mb-5" :key="firstIndex" v-for="(allPost, firstIndex) in imagesToView.stories">
            <v-row justify="left" align="left">
              <v-col class="mb-0 pb-0" md="12" xs="12" v-if="allPost.label">
                <div class="subtitle-1">{{allPost.label}}</div>
              </v-col>
              <v-col class="pt-1" md="4" xs="12" :key="imgIndex" v-for="(img, imgIndex) in allPost.images">
                <v-card text tile>                      
                  <v-hover>
                    <video
                    width="180px"
                    height="200px"
                    v-if="getMediaType(img.url) === 'video'"
                    :src="img.url"
                    controls>             
                        Your browser does not support the video tag.
                    </video>
                    <v-img
                      :src="img.url"
                      :lazy-src="img.url"
                      aspect-ratio="1"
                      class="grey lighten-2 mx-auto"
                      slot-scope="{ hover }"
                      :class="`elevation-${hover ? 12 : 2}`"
                      @click="viewMedia(img.url)"
                      v-else
                    />
                  </v-hover>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </div>

        <!-- Deliverables -->
        <div class="pb-5" v-if="hasDeliverablePosts">
          <div class="h3 mt-2">Contents</div>
          <v-divider class="ma-0 mb-4"></v-divider>
          <div :key="firstIndex" v-for="(allPost, firstIndex) in imagesToView.deliverablePosts">
            <div v-if="filterEmptyPosts(allPost.posts).length > 0">
              <div class="subtitle-1 font-weight-bold">{{getLongPostTitle(allPost.type)}}</div>
              <v-row justify="left" align="left" v-for="(post, pIndex) in filterEmptyPosts(allPost.posts)" :key="pIndex">
                <v-col md="12" xs="12" class="pt-5 pb-0" v-if="post.label && getPostType(allPost.type) === 'label'">
                  <div class="subtitle-2" v-if="getPostType(allPost.type) === 'label'">{{post.label}}</div>
                </v-col>
                <v-col md="4" xs="12" :key="imgIndex" v-for="(img, imgIndex) in post.images">
                  <v-card text tile>                      
                    <v-hover>
                      <video
                      width="180px"
                      height="200px"
                      v-if="getMediaType(img.url) === 'video'"
                      :src="img.url"
                      controls>             
                          Your browser does not support the video tag.
                      </video>
                      <v-img
                        :src="img.url"
                        :lazy-src="img.url"
                        aspect-ratio="1"
                        class="grey lighten-2 mx-auto"
                        slot-scope="{ hover }"
                        :class="`elevation-${hover ? 12 : 2}`"
                        @click="viewMedia(img.url)"
                        v-else
                      />
                    </v-hover>
                  </v-card>
                </v-col>
                <v-col md="12" xs="12" class="pt-0" v-if="post.label && getPostType(allPost.type) === 'url'">
                  <a :href="post.label" target="_blank">
                    <v-btn small class="mt-2" color="secondary"><v-icon float-left>remove_red_eye</v-icon> Open URL</v-btn>
                  </a>
                </v-col>
              </v-row>
              <v-divider class="mb-4"></v-divider>
            </div>
          </div>
        </div>
        <!-- Old Images -->
        <v-row justify="center" align="center" v-if="imagesToView.images && imagesToView.images.length > 0">
          <v-col v-for="img in imagesToView.images" :key="img.index" md="4" xs="12">
            <v-card text tile>                      
              <v-hover>
                <video
                width="180px"
                height="200px"
                v-if="getMediaType(img.url) === 'video'"
                :src="img.url"
                controls>             
                    Your browser does not support the video tag.
                </video>
                <v-img
                  :src="img.url"
                  :lazy-src="img.url"
                  aspect-ratio="1"
                  class="grey lighten-2 mx-auto"
                  slot-scope="{ hover }"
                  :class="`elevation-${hover ? 12 : 2}`"
                  @click="viewMedia(img.url)"
                  v-else
                />
              </v-hover>
            </v-card>
          </v-col>
        </v-row>

        <v-dialog
          v-model="imageViewerDialog"
          max-width="700"
          >
          <v-card>
            <v-card-title
              class="grey lighten-2"
              primary-title
            >
              <v-spacer></v-spacer>
              <v-icon @click="imageViewerDialog = false">close</v-icon>
            </v-card-title>
            <v-card-text class="text-center">
              <v-img :src="activeImage"></v-img>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <a :href="activeImage" download target="_blank">
                <v-btn><v-icon float-left>save_alt</v-icon>Download</v-btn>
              </a>
            </v-card-actions>
          </v-card>
        </v-dialog>
        </v-container>
      </v-card-text>
      <v-card-actions class="ims-modal-actions">
        <v-spacer></v-spacer>
        <v-btn text color="secondary" @click="$emit('input')">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'PayoutScreenshotsDialog',
  props: [
    'value',
    'imagesToView'
  ],
  data() {
    return {
      imageViewerDialog: false,
      activeImage: ''
    }
  },
  computed: {
    hasPosts: function() {
      if (this.imagesToView.posts && this.imagesToView.posts.length > 0) {
        for (let post of this.imagesToView.posts) {
          if (post.instagramPostURL !== '' || (post.images && post.images.length > 0)) {
            return true
          }
        }
      }
      return false
    },
    hasStories: function() {
      if (this.imagesToView.stories && this.imagesToView.stories.length > 0) {
        for (let post of this.imagesToView.stories) {
          if (post.label !== '' || (post.images && post.images.length > 0)) {
            return true
          }
        }
      }
      return false
    },
    hasDeliverablePosts: function() {
      if (this.imagesToView.deliverablePosts && this.imagesToView.deliverablePosts.length > 0) {
        for (let allPosts of this.imagesToView.deliverablePosts) {
          for (let post of allPosts.posts) {
            if (post.label !== '' || (post.images && post.images.length > 0)) {
              return true
            }
          }
        }
      }
      return false
    }
  },
  methods: {
    viewMedia(img) {
      this.activeImage = img
      this.imageViewerDialog = true
    },
    getPostType(type) {
      if (type === 'IGS') {
        return 'label'
      } else return 'url'
    },
    filterEmptyPosts(posts) {
      posts = posts.filter(post => {
        if (post.label || post.images.length > 0) {
          return true
        }
        return false
      })
      return posts
    },
    getLongPostTitle(title) {
      if (title === 'TTP') {
        return `TikTok Post`
      } else if (title === 'IGP') {
        return `IG Post`
      } else if (title === 'IGC') {
        return `IG Carousel`
      } else if (title === 'IGS') {
        return `IG Story`
      } else if (title === 'IGV') {
        return `IG Video`
      } else if (title === 'IGR') {
        return `IG Reel`
      } else return title
    },
    getMediaType(mediaUrl) {
      const videos = ['mp4', 'MP4', 'mov', 'MOV', '3gp', '3GP', 'ogg', 'OGG', 'mpeg4', 'MPEG4']
      const images = ['jpg', 'JPG', 'jpeg', 'JPEG,', 'gif', 'GIF', 'png', 'PNG', 'svg', 'SVG', 'webp', 'WEBP']
      const url = new URL(mediaUrl)
      const extension = url.pathname.split('.')[4] // our media url come with long lengh and array[4] only return the extension
      if (videos.includes(extension)) {
        return 'video'
      } else if (images.includes(extension)) {
        return 'image'
      } else {
        return 'image'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// PayoutScreenshotsDialog.vue?0d6e0d78